import get from "lodash/get";
import moment from "moment";

import { dollars } from "LIB/formatters/currency";
import api from "APP_ROOT/api";
import { getPeriodFilters } from "../../utils";

export const request = api.reports.high_scores.sales_stats;

export const columns = [
  {
    key: "period",
    label: "Period",
    render: record => moment(record.period).format("MMM-YY")
  },
  {
    key: "total_sales",
    label: "Amount",
    render: record => dollars(get(record, "total_sales", 0), 0)
  }
];

export const filters = props => {
  const periodFilters = getPeriodFilters(props);

  return {
    type: "grouped_sales",
    ...periodFilters,
    period: "month",
    exchange: true,
    order: "total_sales"
  };
};

export const color = "#2196F3";



// WEBPACK FOOTER //
// ./app/modules/HighScores/components/StatsTable/getMostExchangeRevenue.js